import BigNumber from "bignumber.js";
import { BASE18 } from "src/configs/constance";
import ABI from "src/contract-logic/abis/VeTravaABI.json";
import { handleEmit } from ".";
import { getCurrentContractAddresses } from "../../configs/address";
import { getWeb3Sender, web3Reader } from "../../wallet-connection";

const { VE_TRAVA_ADDRESS, TRAVA_VE_TOKEN_ADDRESS } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) contractReader = new web3Reader.eth.Contract(ABI, VE_TRAVA_ADDRESS);
  if (!contractReader) throw new Error("Failed to create nft-core contract reader");
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) contractSender = new web3Sender.eth.Contract(ABI, VE_TRAVA_ADDRESS);
  if (!contractSender) throw new Error("Failed to create nft-core contract sender");
  return contractSender;
}

async function locked(tokenId) {
  const res = await getContractReader().methods.locked(tokenId).call();
  const end = new Date(parseInt(res.end) * 1000);
  return {
    amount: BigNumber(res.amount.toString()).dividedBy(BASE18).toNumber(),
    rwAmount: BigNumber(res.rewardAmount.toString()).dividedBy(BASE18).toNumber(),
    lockEnd: end.getDate() + "/" + (end.getMonth() + 1) + "/" + end.getFullYear(),
    token: res.token === TRAVA_VE_TOKEN_ADDRESS ? "TRAVA" : "rTRAVA",
    baseAmount: BigNumber(res.baseAmount.toString()).dividedBy(BASE18).toNumber(),
  };
}
async function getVotingPower(tokenId) {
  const res = await getContractReader().methods.balanceOfNFT(tokenId).call();
  return BigNumber(res.toString()).dividedBy(BASE18).toNumber();
}
async function getBalanceOf(owner) {
  const res = await getContractReader().methods.balanceOf(owner).call();
  return parseInt(res);
}
async function ownerOf(tokenId) {
  const res = await getContractReader().methods.ownerOf(tokenId).call();
  return res;
}
async function approveForAll(dispatch, operatorAddress, accountAddress) {
  const emit = getContractSender().methods.setApprovalForAll(operatorAddress, true).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Approve");
  await emit;
}

async function isApprovedForAll(ownerAddress, operatorAddress, accountAddress) {
  return await getContractReader()
    .methods.isApprovedForAll(ownerAddress, operatorAddress)
    .call({ from: accountAddress });
}

export default {
  ABI,
  ADDRESS: VE_TRAVA_ADDRESS,
  getBalanceOf,
  ownerOf,
  approveForAll,
  isApprovedForAll,
  locked,
  getVotingPower,
};
